import { queryOptions, useQuery } from '@tanstack/react-query';

import { paymentMethodsApi } from '../api/payment-methods-api';

import { paymentMethodKeys } from './payment-method-keys';

export function paymentMethodsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: paymentMethodKeys.list(storeId),
    queryFn: () => paymentMethodsApi.list(storeId),
  });
}

export function usePaymentMethods(storeId: string) {
  return useQuery(paymentMethodsQueryOptions(storeId));
}
